/* Just Married Landingpage (19grams). Präfix jm-. Texte kommen aus der Textbank im HTML (Weglot). */
(function(){
  "use strict";
  var jm = document.getElementById("jm");
  if(!jm) return;
  var $ = function(id){ return document.getElementById(id); };
  var qa = function(sel, root){ return Array.prototype.slice.call((root||jm).querySelectorAll(sel)); };
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var lang = (document.documentElement.lang || "de").slice(0,2);
  var DATA = {};
  try { DATA = JSON.parse($("jm-data").textContent); } catch(e){ DATA = {plans:{}}; }

  function T(key){ var el = jm.querySelector('.jm-bank [data-t="'+key+'"]'); return el ? el.textContent.trim() : ""; }
  function TL(key){ return qa('.jm-bank [data-t="'+key+'"]').map(function(el){ return el.textContent.trim(); }); }
  function fill(s, map){ return String(s).replace(/\{(\w+)\}/g, function(m,k){ return map[k]!=null ? map[k] : m; }); }
  function num(n, dec){ return Number(n).toLocaleString(lang, {minimumFractionDigits:dec||0, maximumFractionDigits:dec||0}); }

  /* ---------- Datum ---------- */
  function parseISO(s){ if(!s) return null; var p=s.split("-"); if(p.length!==3) return null; var d=new Date(+p[0],+p[1]-1,+p[2]); return isNaN(d)?null:d; }
  function fmtDate(s){ var d=parseISO(s); return d ? d.toLocaleDateString(lang,{day:"2-digit",month:"2-digit",year:"numeric"}) : ""; }
  function isoToday(off){ var d=new Date(); d.setDate(d.getDate()+(off||0)); return d.getFullYear()+"-"+String(d.getMonth()+1).padStart(2,"0")+"-"+String(d.getDate()).padStart(2,"0"); }

  /* ---------- Married on: Tage zählen (Paar-Ansicht) ---------- */
  function showDays(kind){ qa("[data-days]").forEach(function(el){ el.hidden = el.getAttribute("data-days")!==kind; }); }
  function setDN(key, val){ qa('[data-dn="'+key+'"]').forEach(function(el){ el.textContent = num(val); }); }
  function updateDays(){
    var d=parseISO($("jm-married").value);
    if(!d){ showDays("none"); return; }
    var today=new Date(); today.setHours(0,0,0,0);
    var day=864e5, diff=Math.round((today-d)/day);
    if(diff<0){ setDN("left",-diff); showDays("future"); return; }
    if(diff===0){ showDays("today"); return; }
    var anniv=new Date(d.getFullYear()+1,d.getMonth(),d.getDate());
    var left=Math.round((anniv-today)/day);
    setDN("day",diff+1);
    if(left>0){ setDN("paper",left); showDays("year"); } else showDays("after");
  }
  $("jm-married").addEventListener("input", function(){
    updateDays();
    if(this.value){ $("jm-f-date").value=this.value; queueCard(); }
  });

  /* ---------- Amor schießt aufs Herz-Logo ---------- */
  var hits=0, flying=false, svgNS="http://www.w3.org/2000/svg";
  var HIT=TL("hit");
  var TIP={x:.042,y:.667}, ANG0=164.1;   // Herzspitze im Pfeil-Sprite, Flugrichtung im Render
  function burst(x,y){
    var fx=$("jm-fx");
    for(var i=0;i<10;i++){
      var s=document.createElementNS(svgNS,"svg"); s.setAttribute("viewBox","0 0 24 24");
      var u=document.createElementNS(svgNS,"use"); u.setAttribute("href","#jm-heart"); s.appendChild(u);
      var size=12+Math.random()*16; s.style.width=s.style.height=size+"px";
      s.style.left=x+"px"; s.style.top=y+"px"; fx.appendChild(s);
      var a=(Math.PI*2)*(i/10)+Math.random()*.5, r=50+Math.random()*50;
      if(!reduce && s.animate){
        s.animate([{transform:"translate(0,0) scale(.4)",opacity:1},{transform:"translate("+(Math.cos(a)*r).toFixed(1)+"px,"+(Math.sin(a)*r-24).toFixed(1)+"px) scale(1)",opacity:0}],{duration:900+Math.random()*350,easing:"cubic-bezier(.2,.7,.3,1)",fill:"forwards"});
      }
      (function(el){ setTimeout(function(){ el.remove(); }, reduce?500:1400); })(s);
    }
  }
  function onHit(){
    var t=$("jm-target"), hero=$("top"), tr=t.getBoundingClientRect(), hr=hero.getBoundingClientRect();
    burst(tr.left-hr.left+tr.width*.49, tr.top-hr.top+tr.height*.48);
    t.classList.remove("is-hit"); void t.offsetWidth; t.classList.add("is-hit");
    hits++; $("jm-hits").textContent=hits; $("jm-hitmsg").textContent=HIT[Math.min(hits-1,HIT.length-1)]||"";
  }
  function shoot(){
    if(flying) return; flying=true;
    var ar=$("jm-arrow"), t=$("jm-target");
    if(reduce || !ar.animate){ onHit(); flying=false; return; }
    var r=ar.getBoundingClientRect(), tr=t.getBoundingClientRect();
    var tipX=r.left+r.width*TIP.x, tipY=r.top+r.height*TIP.y;
    var tx=tr.left+tr.width*.47, ty=tr.top+tr.height*.5;
    var dx=tx-tipX, dy=ty-tipY;
    var rot=Math.atan2(dy,dx)*180/Math.PI-ANG0; rot=((rot+540)%360)-180;
    var dur=Math.max(480,Math.min(950,Math.hypot(dx,dy)*.85));
    var anim=ar.animate([
      {transform:"translate(0px,0px) rotate(0deg)"},
      {transform:"translate("+(-dx*.04)+"px,"+(-dy*.04)+"px) rotate("+rot+"deg)",offset:.14},
      {transform:"translate("+dx+"px,"+dy+"px) rotate("+rot+"deg)"}
    ],{duration:dur,easing:"cubic-bezier(.45,0,.6,1)",fill:"forwards"});
    anim.onfinish=function(){
      onHit();
      setTimeout(function(){ ar.style.opacity="0"; }, 450);
      setTimeout(function(){ anim.cancel(); ar.style.opacity="1"; flying=false; }, 900);
    };
  }
  $("jm-shoot").addEventListener("click", shoot);
  $("jm-stage").addEventListener("click", shoot);

  /* ---------- Abo-Auswahl ---------- */
  var sel={plan:"6",grind:"wb"};
  function variant(){ var P=DATA.plans[sel.plan]; return P && P.v ? (P.v[sel.grind] || P.v.wb) : null; }
  function renderAbo(){
    var P=DATA.plans[sel.plan], v=variant();
    qa("[data-plan]").forEach(function(b){ b.setAttribute("aria-pressed", String(b.getAttribute("data-plan")===sel.plan)); });
    qa("[data-grind]").forEach(function(b){ b.setAttribute("aria-pressed", String(b.getAttribute("data-grind")===sel.grind)); });
    qa("[data-gname]").forEach(function(el){ el.hidden = el.getAttribute("data-gname")!==sel.grind; });
    ["6","12"].forEach(function(k){
      var pv = DATA.plans[k] && DATA.plans[k].v ? (DATA.plans[k].v[sel.grind] || DATA.plans[k].v.wb) : null;
      var el = jm.querySelector('[data-plan-price="'+k+'"]'); if(el && pv) el.textContent = pv.price;
    });
    if(!P || !v) return;
    $("jm-sum-price").textContent=v.price;
    qa('[data-sum="bags"]').forEach(function(el){ el.textContent=P.bags; });
    qa('[data-sum="per"]').forEach(function(el){ el.textContent=v.per; });
    var cta=$("jm-cta");
    cta.href=P.url+"?variant="+v.id;
    var ok = v.available !== false;
    cta.toggleAttribute("aria-disabled", !ok);
    cta.style.pointerEvents = ok ? "" : "none"; cta.style.opacity = ok ? "" : ".45";
    $("jm-soldout").hidden = ok;
  }
  qa("[data-plan]").forEach(function(b){ b.addEventListener("click", function(){ sel.plan=b.getAttribute("data-plan"); renderAbo(); card.plan=sel.plan; syncCardPlan(); queueCard(); }); });
  qa("[data-grind]").forEach(function(b){ b.addEventListener("click", function(){ sel.grind=b.getAttribute("data-grind"); renderAbo(); }); });
  $("jm-cta").addEventListener("click", function(e){
    var P=DATA.plans[sel.plan], v=variant();
    if(!P || !v || !P.plan || !window.fetch) return;   // ohne Abo-Plan: normaler Link zur Produktseite
    e.preventDefault();
    var root=(window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    fetch(root+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items:[{id:v.id,quantity:1,selling_plan:P.plan}]})})
      .then(function(r){ if(!r.ok) throw r; window.location.href=root+"cart"; })
      .catch(function(){ window.location.href=P.url+"?variant="+v.id; });
  });

  /* ---------- Brühhilfe ---------- */
  // Espresso-Rezept aus dem Metafeld (z. B. "1:2,5 (z.B. 19gr Kaffee auf 47,5gr Wasser) in 30-35 Sekunden")
  var ESP={dose:19, ratio:2.5, t1:30, t2:35};
  (function(){
    var s=jm.getAttribute("data-ratio")||"";
    var m=s.match(/1\s*:\s*(\d+(?:[.,]\d+)?)/); if(m) ESP.ratio=parseFloat(m[1].replace(",","."));
    m=s.match(/(\d+(?:[.,]\d+)?)\s*g/i); if(m) ESP.dose=parseFloat(m[1].replace(",","."));
    m=s.match(/(\d+)\s*[-–]\s*(\d+)\s*(?:s|Sek)/i); if(m){ ESP.t1=+m[1]; ESP.t2=+m[2]; }
    else { m=s.match(/(\d+)\s*(?:s|Sek)/i); if(m){ ESP.t1=ESP.t2=+m[1]; } }
    if(!(ESP.ratio>1 && ESP.ratio<5)) ESP.ratio=2.5;
    if(!(ESP.dose>=10 && ESP.dose<=25)) ESP.dose=19;
    if(!(ESP.t2>=15 && ESP.t2<=60)){ ESP.t1=30; ESP.t2=35; }
    var y=ESP.dose*ESP.ratio, y2=ESP.dose*2;
    var dec=function(v){ return Math.round(v)===v ? 0 : 1; };
    var set=function(k,txt){ qa('[data-k="'+k+'"]').forEach(function(el){ el.textContent=txt; }); };
    set("dose", num(ESP.dose, dec(ESP.dose)));
    set("yield", num(y, dec(y)));
    set("yield2", num(y2, dec(y2)));
    set("ratio", "1:"+num(ESP.ratio, dec(ESP.ratio)));
    set("time", ESP.t1===ESP.t2 ? String(ESP.t2) : ESP.t1+"–"+ESP.t2);
    var sb=jm.querySelector('[data-brew="siebtraeger"]'); if(sb) sb.setAttribute("data-timer", ESP.t2);
  })();
  var CALC={
    "cups":function(n){ return num(n); },
    "fp-water":function(n){ return num(250*n); },
    "fp-coffee":function(n){ return num(Math.round(250*n/16)); },
    "fp-half":function(n){ return num(125*n); },
    "fi-water":function(n){ return num(Math.round(262.5*n)); },
    "fi-coffee":function(n){ return num(Math.round(14.5*n)); }
  };
  var brew={method:"siebtraeger",cups:2}, timerId=null, tLeft=0, tTotal=0;
  function fmtT(s){ var m=Math.floor(s/60), r=s%60; return m+":"+(r<10?"0":"")+r; }
  function stopTimer(){ if(timerId){ clearInterval(timerId); timerId=null; } $("jm-t-start").textContent=T("t-start"); }
  function renderBrew(){
    var n=brew.cups, body=jm.querySelector('[data-brew="'+brew.method+'"]');
    qa("[data-method]").forEach(function(b){ b.setAttribute("aria-pressed", String(b.getAttribute("data-method")===brew.method)); });
    qa("[data-brew]").forEach(function(el){ el.hidden = el!==body; });
    $("jm-cups").textContent=n;
    $("jm-cups-minus").disabled=n<=1; $("jm-cups-plus").disabled=n>=4;
    qa("[data-show]").forEach(function(el){
      var w=el.getAttribute("data-show");
      el.hidden = w==="many" ? n<2 : w!==String(n);
    });
    qa("[data-calc]").forEach(function(el){ var f=CALC[el.getAttribute("data-calc")]; if(f) el.textContent=f(n); });
    stopTimer();
    tTotal=+(body.getAttribute("data-timer")||0); tLeft=tTotal;
    $("jm-timer").hidden=!tTotal;
    $("jm-t-out").textContent=fmtT(tLeft);
    var note=body.getAttribute("data-timer-note"); $("jm-t-note").textContent = note ? T(note) : "";
    $("jm-fix").hidden = body.getAttribute("data-fix")!=="1";
  }
  qa("[data-method]").forEach(function(b){ b.addEventListener("click", function(){ brew.method=b.getAttribute("data-method"); renderBrew(); }); });
  $("jm-cups-minus").addEventListener("click", function(){ if(brew.cups>1){ brew.cups--; renderBrew(); } });
  $("jm-cups-plus").addEventListener("click", function(){ if(brew.cups<4){ brew.cups++; renderBrew(); } });
  $("jm-t-start").addEventListener("click", function(){
    if(timerId){ stopTimer(); return; }
    if(tLeft<=0) tLeft=tTotal;
    this.textContent=T("t-pause");
    timerId=setInterval(function(){
      tLeft--; $("jm-t-out").textContent=fmtT(Math.max(tLeft,0));
      if(brew.method==="aeropress" && tLeft===30) $("jm-t-note").textContent=T("t-press");
      if(tLeft<=0){ stopTimer(); $("jm-t-note").textContent=T("t-done"); }
    },1000);
  });
  $("jm-t-reset").addEventListener("click", function(){ stopTimer(); renderBrew(); });
  qa("[data-fix-btn]").forEach(function(b){ b.addEventListener("click", function(){
    var k=b.getAttribute("data-fix-btn");
    qa("[data-fix-btn]").forEach(function(x){ x.setAttribute("aria-pressed", String(x===b)); });
    qa("[data-fix-text]").forEach(function(p){ p.hidden = p.getAttribute("data-fix-text")!==k; });
  }); });

  /* ---------- Karten-Generator ---------- */
  var GIFT=TL("gift-msg"), THANKS=TL("thanks-msg");
  var card={mode:"gift",plan:"6",start:"now",msgGift:GIFT[0]||"",msgThanks:THANKS[0]||""};
  var gi=0, ti=0, cardModeTouched=false;
  var cv=$("jm-canvas"), ctx=cv.getContext("2d");
  var W=2480,H=1748, LEFT=1040, INK="#1D1D1B", RED="#C81E39", MUTED="#6B4D53", GOLD="#8F6512";
  var panels={}, fontsReady=null, qrImg=null, logoImg=null;
  var FONT=(getComputedStyle(jm).getPropertyValue("--font-body-family")||"").trim() || "Jost";
  var SCRIPT='"JM Yellowtail"';

  function setCardMode(m, auto){
    card.mode=m;
    if(!auto) cardModeTouched=true;
    qa("[data-mode]").forEach(function(b){ b.setAttribute("aria-pressed", String(b.getAttribute("data-mode")===m)); });
    qa("[data-only]").forEach(function(el){ el.hidden = el.getAttribute("data-only")!==m; });
    $("jm-f-msg").value = m==="gift"?card.msgGift:card.msgThanks;
    updateCount(); updateCal(); queueCard();
  }
  qa("[data-mode]").forEach(function(b){ b.addEventListener("click", function(){ setCardMode(b.getAttribute("data-mode")); }); });
  function syncCardPlan(){ qa("[data-cplan]").forEach(function(b){ b.setAttribute("aria-pressed", String(b.getAttribute("data-cplan")===card.plan)); }); }
  qa("[data-cplan]").forEach(function(b){ b.addEventListener("click", function(){ card.plan=b.getAttribute("data-cplan"); syncCardPlan(); sel.plan=card.plan; renderAbo(); updateCal(); queueCard(); }); });
  qa("[data-start]").forEach(function(b){ b.addEventListener("click", function(){
    card.start=b.getAttribute("data-start");
    qa("[data-start]").forEach(function(x){ x.setAttribute("aria-pressed", String(x===b)); });
    $("jm-f-later").hidden = card.start!=="later"; updateCal(); queueCard();
  }); });
  function updateCount(){ $("jm-f-count").textContent=$("jm-f-msg").value.length+" / 220"; }
  $("jm-f-msg").addEventListener("input", function(){ if(card.mode==="gift") card.msgGift=this.value; else card.msgThanks=this.value; updateCount(); queueCard(); });
  $("jm-dice").addEventListener("click", function(){
    var t;
    if(card.mode==="gift"){ gi=(gi+1)%GIFT.length; t=card.msgGift=GIFT[gi]; }
    else { ti=(ti+1)%THANKS.length; t=card.msgThanks=THANKS[ti]; }
    $("jm-f-msg").value=t; updateCount(); queueCard();
  });
  ["jm-f-couple","jm-f-date","jm-f-to","jm-f-from","jm-f-startdate"].forEach(function(id){ $(id).addEventListener("input", function(){ updateCal(); queueCard(); }); });
  $("jm-card-form").addEventListener("submit", function(e){ e.preventDefault(); });

  function loadImg(src){ return new Promise(function(res){ var i=new Image(); i.crossOrigin="anonymous"; i.onload=function(){ res(i); }; i.onerror=function(){ res(null); }; i.src=src; }); }
  function loadPanel(mode){ if(!panels[mode]) panels[mode]=loadImg(jm.getAttribute(mode==="gift"?"data-card-gift":"data-card-thanks")); return panels[mode]; }
  function loadLogo(){
    if(logoImg) return logoImg;
    var el=jm.querySelector(".jm-dlogo"); if(!el){ logoImg=Promise.resolve(null); return logoImg; }
    var svg=el.outerHTML;
    if(svg.indexOf("xmlns=")<0) svg=svg.replace("<svg","<svg xmlns=\"http://www.w3.org/2000/svg\"");
    var img=new Image();
    logoImg=new Promise(function(res){ img.onload=function(){ res(img); }; img.onerror=function(){ res(null); }; img.src="data:image/svg+xml;charset=utf-8,"+encodeURIComponent(svg); });
    return logoImg;
  }
  function ensureFonts(){
    if(fontsReady) return fontsReady;
    var list=["800 80px "+FONT,"700 80px "+FONT,"600 80px "+FONT,"500 80px "+FONT,"400 80px "+FONT,"400 80px "+SCRIPT];
    fontsReady = (document.fonts && document.fonts.load) ? Promise.all(list.map(function(f){ return document.fonts.load(f).catch(function(){}); })) : Promise.resolve();
    return fontsReady;
  }
  function buildQR(){
    if(qrImg) return qrImg;
    if(typeof window.qrcode!=="function") return null;
    try{
      var q=window.qrcode(0,"H"); q.addData(jm.getAttribute("data-lp")+"?ref=karte"); q.make();
      var n=q.getModuleCount(), s=8, pad=2, c=document.createElement("canvas");
      c.width=c.height=(n+pad*2)*s; var x=c.getContext("2d");
      x.fillStyle="#FFFFFF"; x.fillRect(0,0,c.width,c.height); x.fillStyle=INK;
      for(var r=0;r<n;r++) for(var k=0;k<n;k++) if(q.isDark(r,k)) x.fillRect((k+pad)*s,(r+pad)*s,s,s);
      qrImg=c;
    }catch(e){ qrImg=null; }
    return qrImg;
  }
  function F(w,s,fam){ return w+" "+s+"px "+(fam||FONT); }
  function fitFont(text, weight, fam, max, min, maxW){
    var s=max; ctx.font=F(weight,s,fam);
    while(s>min && ctx.measureText(text).width>maxW){ s-=4; ctx.font=F(weight,s,fam); }
    return s;
  }
  function wrap(text, maxW){
    var out=[];
    String(text||"").split(/\n/).forEach(function(par){
      var words=par.split(/\s+/).filter(Boolean), line="";
      words.forEach(function(w){ var t=line?line+" "+w:w; if(ctx.measureText(t).width>maxW && line){ out.push(line); line=w; } else line=t; });
      if(line) out.push(line);
    });
    return out;
  }
  function spaced(text, x, y, sp){
    var chars=text.split(""), w=0; chars.forEach(function(c){ w+=ctx.measureText(c).width+sp; }); w-=sp;
    var cx=x-w/2; ctx.textAlign="left";
    chars.forEach(function(c){ ctx.fillText(c,cx,y); cx+=ctx.measureText(c).width+sp; });
    ctx.textAlign="center";
  }
  function labelRow(x0,w,y,cols){
    var cw=w/cols.length;
    cols.forEach(function(c,i){
      var cx=x0+cw*i+cw/2;
      ctx.fillStyle=INK; ctx.font=F(700,34); spaced(c[0].toUpperCase(),cx,y,3);
      ctx.font=F(400,44); ctx.fillText(c[1],cx,y+58);
      if(c[2]){ ctx.font=F(500,44); ctx.fillText(c[2],cx,y+112); ctx.fillRect(cx-150,y+126,300,3); }
    });
  }
  function roundRect(x,y,w,h,r){ ctx.beginPath(); ctx.moveTo(x+r,y); ctx.arcTo(x+w,y,x+w,y+h,r); ctx.arcTo(x+w,y+h,x,y+h,r); ctx.arcTo(x,y+h,x,y,r); ctx.arcTo(x,y,x+w,y,r); ctx.closePath(); }
  var drawTimer=null;
  function queueCard(){ clearTimeout(drawTimer); drawTimer=setTimeout(drawCard,60); }
  function drawCard(){
    var mode=card.mode;
    return Promise.all([ensureFonts(), loadPanel(mode), loadLogo()]).then(function(r){
      var panel=r[1], logo=r[2];
      ctx.setTransform(1,0,0,1,0,0);
      ctx.fillStyle="#FFFFFF"; ctx.fillRect(0,0,W,H);
      if(panel) ctx.drawImage(panel,0,0,LEFT,H); else { ctx.fillStyle="#F6B8BE"; ctx.fillRect(0,0,LEFT,H); }
      if(logo) ctx.drawImage(logo,60,60,210,210);
      var x0=LEFT+120, tw=W-x0-120, cx=x0+tw/2;
      var couple=$("jm-f-couple").value.trim()||T("c-couple"), date=fmtDate($("jm-f-date").value)||"______";
      ctx.textAlign="center"; ctx.textBaseline="alphabetic"; ctx.fillStyle=INK;
      ctx.font=F(700,70); ctx.fillText("Just Married",cx,200);
      if(mode==="gift"){
        fitFont(couple,"400",SCRIPT,176,90,tw); ctx.fillStyle=RED; ctx.fillText(couple,cx,392);
        labelRow(x0,tw,500,[["Altitude","Cloud 9"],["Varietal","Big Love"],["Process","Married on",date]]);
        ctx.fillStyle=INK; ctx.font=F(400,54);
        wrap($("jm-f-msg").value,tw-40).slice(0,5).forEach(function(l,i){ ctx.fillText(l,cx,790+i*76); });
        var P=DATA.plans[card.plan]||{bags:+card.plan}, by=1160;
        ctx.font=F(400,38);
        var desc=wrap(T("c-desc"),tw-100).slice(0,2);
        var bh=226+desc.length*50;
        ctx.fillStyle="#FDEBEE"; roundRect(x0,by,tw,bh,28); ctx.fill();
        ctx.fillStyle=GOLD; ctx.font=F(700,30); spaced(T("c-gift"),cx,by+62,5);
        ctx.fillStyle=INK; ctx.font=F(600,48); ctx.fillText(fill(T("c-months"),{n:P.bags}),cx,by+128);
        ctx.font=F(400,38); desc.forEach(function(l,i){ ctx.fillText(l,cx,by+184+i*50); });
        var sd=$("jm-f-startdate").value;
        var st = card.start==="later" && sd ? fill(T("c-start-later"),{date:fmtDate(sd)}) : T("c-start-now");
        ctx.font=F(500,38); ctx.fillStyle=RED; ctx.fillText(st,cx,by+184+desc.length*50+12);
        var from=$("jm-f-from").value.trim(), q=buildQR();
        if(from){ var ft=fill(T("c-from"),{name:from}); ctx.fillStyle=INK; ctx.textAlign="left"; fitFont(ft,"400",SCRIPT,96,56,tw-300); ctx.fillText(ft,x0,1650); ctx.textAlign="center"; }
        if(q){
          var qs=170, qx=W-120-qs, qy=1510;
          ctx.drawImage(q,qx,qy,qs,qs);
          if(logo){ ctx.fillStyle="#FFFFFF"; ctx.fillRect(qx+qs*.36,qy+qs*.36,qs*.28,qs*.28); ctx.drawImage(logo,qx+qs*.37,qy+qs*.37,qs*.26,qs*.26); }
          ctx.fillStyle=MUTED; ctx.font=F(500,24); ctx.fillText(T("c-qr"),qx+qs/2,qy+qs+30);
        }
      } else {
        ctx.fillStyle=RED; ctx.font=F(400,210,SCRIPT); ctx.fillText(T("c-thanks"),cx,430);
        var to=$("jm-f-to").value.trim();
        if(to){ ctx.fillStyle=INK; ctx.font=F(500,50); ctx.fillText(fill(T("c-for"),{name:to}),cx,512); }
        labelRow(x0,tw,600,[["Altitude","Cloud 9"],["Varietal","Big Love"],["Process","Married on",date]]);
        ctx.fillStyle=INK; ctx.font=F(400,56);
        wrap($("jm-f-msg").value,tw-40).slice(0,5).forEach(function(l,i){ ctx.fillText(l,cx,900+i*80); });
        ctx.font=F(500,44); ctx.fillStyle=MUTED; ctx.fillText(T("c-yours"),cx,1430);
        ctx.fillStyle=INK; fitFont(couple,"400",SCRIPT,150,80,tw); ctx.fillText(couple,cx,1580);
        ctx.fillStyle=MUTED; ctx.font=F(500,28); ctx.fillText("19grams.coffee",cx,H-64);
      }
    });
  }

  function slug(s){ return (s||"karte").toLowerCase().replace(/&/g,"und").replace(/ä/g,"ae").replace(/ö/g,"oe").replace(/ü/g,"ue").replace(/ß/g,"ss").replace(/[^a-z0-9]+/g,"-").replace(/^-|-$/g,"")||"karte"; }
  function status(t){ $("jm-status").textContent=t; }
  function saveBlob(name, blob){
    if(!blob) throw new Error("no blob");
    var url=URL.createObjectURL(blob), a=document.createElement("a");
    a.href=url; a.download=name; a.rel="noopener"; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function(){ URL.revokeObjectURL(url); },4000);
  }
  function fileBase(){ return "just-married-"+slug(T(card.mode==="gift"?"file-gift":"file-thanks"))+"-"+slug($("jm-f-couple").value); }
  var pdfLib=null;
  function loadPdfLib(){
    if(window.jspdf) return Promise.resolve();
    if(pdfLib) return pdfLib;
    pdfLib=new Promise(function(res,rej){ var s=document.createElement("script"); s.src=jm.getAttribute("data-jspdf"); s.onload=res; s.onerror=function(){ pdfLib=null; rej(); }; document.head.appendChild(s); });
    return pdfLib;
  }
  $("jm-pdf").addEventListener("click", function(){
    status(T("s-pdf"));
    Promise.all([loadPdfLib(), drawCard()]).then(function(){
      var doc=new window.jspdf.jsPDF({orientation:"landscape",unit:"mm",format:"a5"});
      doc.setProperties({title:"Just Married",creator:"19grams"});
      doc.addImage(cv.toDataURL("image/jpeg",0.93),"JPEG",0,0,210,148);
      saveBlob(fileBase()+".pdf", doc.output("blob"));
      status(T("s-ok"));
    }).catch(function(){ status(T("s-err")); });
  });
  $("jm-png").addEventListener("click", function(){
    status(T("s-png"));
    drawCard().then(function(){ return new Promise(function(res){ cv.toBlob(res,"image/png"); }); })
      .then(function(b){ saveBlob(fileBase()+".png", b); status(T("s-ok")); })
      .catch(function(){ status(T("s-err")); });
  });
  function ymd(d){ return d.getFullYear()+String(d.getMonth()+1).padStart(2,"0")+String(d.getDate()).padStart(2,"0"); }
  function updateCal(){
    var a=$("jm-cal"), d=parseISO($("jm-f-startdate").value);
    var show = card.mode==="gift" && card.start==="later" && !!d;
    a.hidden=!show; if(!show) return;
    var remind=new Date(d); remind.setDate(remind.getDate()-3);
    var today=new Date(); today.setHours(0,0,0,0); if(remind<today) remind=today;
    var end=new Date(remind); end.setDate(end.getDate()+1);
    var P=DATA.plans[card.plan]||{url:""};
    var details=fill(T("cal-details"),{date:fmtDate($("jm-f-startdate").value), name:($("jm-f-couple").value.trim()||T("cal-couple"))})+" "+location.origin+P.url;
    a.href="https://calendar.google.com/calendar/render?action=TEMPLATE&text="+encodeURIComponent(T("cal-title"))+"&dates="+ymd(remind)+"/"+ymd(end)+"&details="+encodeURIComponent(details);
  }

  /* ---------- Ansicht ---------- */
  function applyView(){
    var couple = jm.getAttribute("data-view")==="couple";
    if(!cardModeTouched) setCardMode(couple ? "thanks" : "gift", true);
  }

  /* ---------- Start ---------- */
  $("jm-f-date").value = isoToday(0);
  $("jm-f-startdate").value = isoToday(21);
  renderAbo(); renderBrew(); updateDays();
  applyView();
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ fontsReady=null; queueCard(); });
  // QR-Bibliothek wird mit defer geladen; danach Karte neu zeichnen
  window.addEventListener("load", function(){ queueCard(); });
})();
